const loaderSizes = {
  sm: 'h-12 w-12',
  md: 'h-14 w-14',
  lg: 'h-16 w-16',
}

export const useTheme = props => {
  const {size = 'md'} = props

  return {
    loaderSize: loaderSizes[size],
  }
}
